import {
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  // 时间筛选器
  RANGE_TIME,
} from '@intelligence/components/Filter/FilterBase/_config';
import {
  getTopSource,
  getTopSources,
  sectionalRankMetricSorter,
} from '@/pages/intelligence/_config/storeRank/utils';
import {
  PC_PLATFORM_STEAM,
  PC_TOP_TOP_SELLERS,
  PC_TOPS,
  PC_SOURCE_STEAM_TOP_SELLERS,
} from '@/pages/intelligence/_config/storeRank/config';

import type { IRegionValue } from '@/pages/intelligence/types/common';
import type {
  IStoreRankDetailsRankResData,
  IStoreRankDetailsResData,
} from '@/pages/intelligence/types/storeRank';
import type { IStoreRankDetailsFilter } from '../types';

export const getIsSteamTopSellers = (option: { platform: string; top: string; }): boolean => {
  const { platform, top } = option ?? {};
  const flag1 = platform === PC_PLATFORM_STEAM;
  const flag2 = top === PC_TOP_TOP_SELLERS;
  return flag1 && flag2;
};

export const getIsSectionalRank = (option: {
  platform: string;
  top: string;
  regions: IRegionValue;
}): boolean => {
  const isSteamTopSellers = getIsSteamTopSellers(option);
  return isSteamTopSellers && option?.regions?.length > 1;
};

const rankMetricSorter = (
  a: IStoreRankDetailsRankResData,
  b: IStoreRankDetailsRankResData,
): number => {
  const aIndex = PC_TOPS.findIndex((item) => a?.name?.endsWith(item));
  const bIndex = PC_TOPS.findIndex((item) => b?.name?.endsWith(item));
  if (aIndex === -1) return 1;
  if (bIndex === -1) return 0;
  return aIndex - bIndex;
};

const sortResData = (
  data: IStoreRankDetailsResData[],
  sorter: (a: IStoreRankDetailsRankResData, b: IStoreRankDetailsRankResData) => number,
): IStoreRankDetailsResData[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const metrics = item?.metric?.sort(sorter) ?? [];
    return {
      ...item,
      metric: metrics,
    };
  });
};

export const handleResData = (
  data: IStoreRankDetailsResData[],
  cfg: {
    isSectionalRank: boolean;
  },
): IStoreRankDetailsResData[] => {
  if (cfg?.isSectionalRank) return sortResData(data, sectionalRankMetricSorter);
  return sortResData(data, rankMetricSorter);
};

export const getInitialFetchParams = (
  isOperate: boolean,
  filterExtend: any,
  defaultFetchParams: any,
): any => {
  if (!isOperate || !filterExtend) return defaultFetchParams;
  const rangeTimeFilterExtend = filterExtend?.[RANGE_TIME];
  const regionFilterExtend = filterExtend?.[REGION_SELECT_FILTER];
  const source = getTopSource(defaultFetchParams?.platform, defaultFetchParams?.top);
  const isMonthly = rangeTimeFilterExtend?.granularity === 'monthly';
  const realRangeTimeFilterExtend = isMonthly ? defaultFetchParams : rangeTimeFilterExtend;

  return {
    ...defaultFetchParams,
    regions:
      source !== PC_SOURCE_STEAM_TOP_SELLERS
        ? ['global']
        : regionFilterExtend?.markets?.length
          ? regionFilterExtend?.markets
          : defaultFetchParams?.regions,
    granularity: realRangeTimeFilterExtend?.granularity,
    start_date: realRangeTimeFilterExtend?.start_date,
    end_date: realRangeTimeFilterExtend?.end_date,
  };
};

export const getParams = (
  filter: IStoreRankDetailsFilter,
  filterPayload?: IStoreRankDetailsFilter,
) => {
  const granularity = filterPayload?.granularity ?? filter?.granularity ?? 'daily';
  const startDate = filterPayload?.start_date ?? filter?.start_date ?? '';
  const endDate = filterPayload?.end_date ?? filter?.end_date ?? '';
  const platform = filterPayload?.platform ?? filter?.platform ?? PC_PLATFORM_STEAM;
  const top = filterPayload?.top ?? filter?.top ?? PC_TOP_TOP_SELLERS;
  const sources = getTopSources(platform, top);
  const regionType = filterPayload?.region_type ?? filter?.region_type ?? 'region';
  const regions = filterPayload?.regions ?? filter?.regions ?? ['global'];

  return {
    granularity,
    startDate,
    endDate,
    sources,
    regionType,
    regions,
  };
};
